module.exports = {
  init: async function(parent,settings={}){
    this._parent=parent;
    this._settings=settings;
    this._cache=false;
    this._key_prefix='catchup-';
  },
  refresh:async function(key)
  {
    this._cache=false;
    await this.get(key);
  },
  get:async function(key,force=false)
  {
    if(!key && key.length <= 0)
    {
      this._parent._log('debug','catchup.get','key is empty',key);
      return false;
    }

    if(!this._cache || this._cache==null || !(typeof this._cache == 'object'))
    {
      this._cache={};
    }

    if(force)
    {
      delete this._cache[key];
    }
    this._parent._log('debug','catchup.get','Getting '+key, force);
    if(this._cache && typeof this._cache == 'object' && (key in this._cache))
    {
      this._parent._log('debug','catchup.get','Has Cache',this._cache[key]);
    }
    else
    {
      this._parent._log('debug','catchup.get','No cache');
      this._cache[key] = {'id': this._key_prefix+key, 'data':{}, 'status': 'published'};
      let current_data = await this._parent.get('local','id='+this._cache[key].id+'');
      console.error('@local.current_data',current_data);
      if(Array.isArray(current_data) && current_data.length == 1)
      {
        this._parent._log('debug','catchup.get','Processing return',current_data);
        if('data' in current_data[0])
        {
          this._cache[key].data = JSON.parse(JSON.stringify(current_data[0].data));
          this._parent._log('debug','catchup.get','From db',this._cache[key]);
        }
        else
        {
          this._parent._log('debug','catchup.get','mmm data missing',current_data[0]);
        }
      }
      else
      {
        this._parent._log('warn','catchup.get','Ok, no return... probably ok',current_data);
      }
    }
    return this._cache[key];
  },
  has:async function(key,post_id=false,callback=false)
  {
    let current_data = await this.get(key);
    let result = false;
    if(typeof current_data === 'object' && 'data' in current_data)
    {
      if(post_id)
      {
        if(post_id in current_data.data)
        {
          if('name' in current_data && current_data.name=='readlater')
          {
            result=true;
          }
        }
      }
      else
      {
        result = 0;
        for(let aRecord in current_data.data)
        {
          result++;
        }
      }
    }
    if(typeof callback == 'function')
    {
      callback(result);
    }
    return result;
  },
  remove:async function(key,post_id)
  {
    if(!this._cache || typeof this._cache !== 'object')
    {
      await this.get(key,true);
    }

    try
    {
      if((key in this._cache) && ('data' in this._cache[key] ))
      {
        if( post_id in this._cache[key].data)
        {
          delete this._cache[key].data[post_id];
          this._parent._log('error','catchup.remove','Removing '+post_id,this._cache[key].data);
          return await this.set(key, JSON.parse(JSON.stringify(this._cache[key].data)));
        }
      }
    }
    catch(ex)
    {
      this._parent._log('error','catchup.remove','Error',ex);
    }
    return true;
  },
  set:async function(key,data,post_id=false)
  {
    try
    {
      if(key && key.length > 0)
      {
        let current_data = await this.get(key);
        if(typeof current_data === 'object' && 'data' in current_data)
        {
          if(post_id)
          {
            this._parent._log('debug','catchup.set','Adding '+post_id,data);
            current_data.data[post_id]=data;
          }
          else
          {
            this._parent._log('debug','catchup.set','Setting to',data);
            current_data.data=data;
          }
          this._parent._log('debug','catchup.set','Persisting',current_data);


          if('id' in current_data)
          {
            let result =  await this._parent.post('local',current_data);
            if(result)
            {
              await this.get(key);
            }
            return result;
          }
          else
          {
            return false;
          }

        }
        else
        {
          throw "current_data is not an object or is missing data";
        }
      }
      else
      {
        throw "key is empty";
      }

    }
    catch(ex)
    {
        this._parent._log('error','catchup.set',ex);
        return false;
    }

  }
}
